import { gql } from '@apollo/client'

// Aliased to createOfferOrders, so both mutations answer with the same data shape.
export const MUTATION_CREATE_BULK_OFFER_ORDERS = gql`
  mutation mutationCreateBulkOfferOrders($input: OfferOrdersInput!) {
    createOfferOrders: createBulkOfferOrders(input: $input) {
      offerOrders {
        caseItems {
          id
          data {
            deviceDefinition {
              id
              name
            }
            requestedRentCategory {
              deviceDefinition {
                id
              }
            }
          }
        }
      }
    }
  }
`
